module.exports = __webpack_public_path__ + "static/media/verification_character.357b1928.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/verification_character.png
// module id = 1108
// module chunks = 21